// extracted by css-extract-rspack-plugin
export default {"container":"container-r6PJ5a","content":"content-sU5upU","title":"title-E63uwv text-display-lg","description":"description-HO2CTV text-body-md-light"};